import { Box } from '@mui/material';
import React from 'react';

import { ChartSurfaceProvider } from 'contexts/chart/chart-surface-context';
import BenchmarkAnalytics from 'views/benchmark-analytics/benchmark-analytics';
import GrowthFilterPanel from './components/growth-filters';
import GrowthKpiSection from './components/growth-kpi-section';
import GrowthTableSection from './components/growth-table-section';
import GrowthTrendCard from './components/growth-trend-card';
import { GrowthProvider } from './context/growth-context';

// One chart surface for the whole body, so every section follows the same light or dark mode.
const Growth: React.FC = () => (
  <BenchmarkAnalytics>
    <GrowthProvider>
      <ChartSurfaceProvider>
        <Box display="flex" flexDirection="column" gap={6}>
          <GrowthFilterPanel />
          <GrowthKpiSection />
          <GrowthTrendCard />
          <GrowthTableSection />
        </Box>
      </ChartSurfaceProvider>
    </GrowthProvider>
  </BenchmarkAnalytics>
);

export default Growth;
